export default "__VITE_ASSET__DWdQ_I9f__"